import { currentUser } from "lib/currentUser"
import keysToCamel from "lib/keysToCamel"
import { DEFAULT_USER_STATE } from "@theconversation/promos-client"

/**
 * Fetch and return user data relevant to promos.
 *
 * This method asynchronously fetches user details via currentUser() and stores them to local storage.
 * Meanwhile, it immediately returns the current value from local storage. This approach returns user
 * data immediately while guaranteeing that any changes will be propagated after two calls (ie. two
 * page loads).
 */
const getUserDataWhileRevalidate = (storage) => {
  // Fetch user and store donation details to localStorage
  if (storage) {
    currentUser().then((tcUser) => {
      const lsUser = JSON.parse(storage.getItem("user")) || { ...DEFAULT_USER_STATE }
      lsUser.donations = keysToCamel(tcUser.donations)
      storage.setItem("user", JSON.stringify(lsUser))
    })
  }

  // Fetch user details from localStorage
  return (storage && JSON.parse(storage.getItem("user"))) || DEFAULT_USER_STATE
}

export default getUserDataWhileRevalidate
